module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_3016.7cf0512f.png";